import { Box } from '@material-ui/core';

import { useWidth } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useWidth';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';
import { PaymentIntent } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/PaymentIntent/PaymentIntent';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface NextActionCompleteOnboardingProps {
  paymentMethodDetailEntity: BnplPaymentMethodDetailEntity;
}

export const NextActionCompleteOnboarding = ({ paymentMethodDetailEntity }: NextActionCompleteOnboardingProps) => {
  const { width, ref } = useWidth<HTMLDivElement>();

  const allowedToCompleteOnboarding = paymentMethodDetailEntity.isAgentAllowedToCompleteOnboarding();

  const isSmall = width && width < 500;

  return (
    <CustomPaper fill="paper">
      <div ref={ref}>
        <Box
          display="flex"
          alignItems="flex-start"
          flexDirection={isSmall ? 'column' : 'row'}
          width="100%"
          gridGap={24}
        >
          <FlexColumn gridGap={4} flexGrow={1} minWidth={0}>
            {allowedToCompleteOnboarding && (
              <Font variant="subtitle1" color="textPrimary" display="block">
                <Text strong tId={'CONTINUE_APPLICATION'} />
              </Font>
            )}
            <Font variant="body2" color="textPrimary" display="block" style={{ minWidth: 0 }}>
              <Text
                tId={allowedToCompleteOnboarding ? 'CONTINUE_APPLICATION_TEXT' : 'CUSTOMER_CONTINUE_APPLICATION_TEXT'}
              />
            </Font>
          </FlexColumn>
          {allowedToCompleteOnboarding && (
            <Box flexShrink={0} display="flex" alignItems="center">
              <PaymentIntent paymentMethodDetailEntity={paymentMethodDetailEntity} />
            </Box>
          )}
        </Box>
      </div>
    </CustomPaper>
  );
};
